(function() {
    if (!window.location.pathname.includes('/cart')) {
        try {
            const originalFetch = window.fetch;
            window.fetch = function(resource, config) {
                if (typeof resource === 'string' && resource.includes('/cart/add')) {
                    sessionStorage.setItem('tl_free_gift_just_added', 'true');
                }
                return originalFetch.apply(this, arguments);
            };

            window.addEventListener('submit', function(e) {
                const action = e.target.getAttribute('action');
                if (action && action.includes('/cart/add')) {
                    sessionStorage.setItem('tl_free_gift_just_added', 'true');
                }
            });
        } catch (e) {}
    } 
    else {
        function initCustomOverride() {
            if (window.tlFreeGiftOffer) {
                const originalUpdateCartData = window.tlFreeGiftOffer.updateCartData;
                
                window.tlFreeGiftOffer.updateCartData = async function() {
                    try {
                        const isJustAdded = sessionStorage.getItem('tl_free_gift_just_added') === 'true';
                        
                        if (isJustAdded) {
                            this.cartHasChanged = true;
                            sessionStorage.removeItem('tl_free_gift_just_added');
                        }
                    } catch (e) {}
                    
                    return originalUpdateCartData.apply(this, arguments);
                };
                
                try {
                    const isJustAdded = sessionStorage.getItem('tl_free_gift_just_added') === 'true';
                    if (isJustAdded) {
                        window.tlFreeGiftOffer.updateCartData();
                    }
                } catch (e) {
                    window.tlFreeGiftOffer.updateCartData();
                }
            } else {
                setTimeout(initCustomOverride, 50);
            }
        }
        initCustomOverride();
    }
})();
